import React, { useEffect, useState } from "react";
import "./Bookings.css";
import Common_Back_Header from "../../../../common/common_components/common_back_header/Common_Back_Header";
import { getAllOrder } from "../../../../../features/order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import Booking_Details_Card from "../booking_details_card/Booking_Details_Card";
import { myRoomBookings } from "../../../../../features/my_account/Slice";
import { encodeId, formatNewDate, formatTimeAMPM } from "../../../../../utils/common";

const Bookings = () => {
  const [showCouponModal, setShowCouponModal] = useState(false);

  const data = [
    {
      order_id: 75843,
      item_no: 1,
      price: 1200,
      date: "13th May | 03:28 pm",
      subtext: "Delivering in 10 mins",
    },
  ];

  const dispatch = useDispatch();
  const bookings = useSelector((state) => state.myaccount.room_bookings);
  useEffect(() => {
    dispatch(myRoomBookings({}));
  }, [dispatch]);

  console.log({ bookings });

  return (
    <>
      <section className="Bookings">
        {[...(bookings?.data || [])]
          .sort((a, b) => b.id - a.id) // Latest first
          .map((item) => (
            <Booking_Details_Card
              key={item?.id}
              orderId={item?.Room?.name || " "}
              no_of_items={item?.total_nights || "0"}
              date={
                formatNewDate(item?.check_in_date) +
                " at " +
                formatTimeAMPM(item?.check_in_time)
              }
              data={item}
              price={item?.total_amount || "0"}
              subtext={item?.Booking_Status?.name || "Pending"}
              onClick={() => setShowCouponModal(true)}
              baseLike={`/guest-house-details/${encodeId(item?.room_id)}`}
            />
          ))}
        <div className="no_data_main_div">
          <p className="no_data_text">No more orders to show</p>
        </div>
      </section>

      {/* <OrderTrackModal
        show={showCouponModal}
        onHide={() => { setShowCouponModal(false) }}
      /> */}
    </>
  );
};

export default Bookings;
